import { render, staticRenderFns } from "./mis-datos-profesionales.vue?vue&type=template&id=53ab1e99&scoped=true"
import script from "./mis-datos-profesionales.vue?vue&type=script&lang=js"
export * from "./mis-datos-profesionales.vue?vue&type=script&lang=js"
import style0 from "./mis-datos-profesionales.vue?vue&type=style&index=0&id=53ab1e99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab1e99",
  null
  
)

export default component.exports